var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPear = function SvgPear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillOpacity: 0,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.866 7.182A2.275 2.275 0 0 0 9.468 9.06l-.009.065a6.6 6.6 0 0 1-1.88 3.613A5.33 5.33 0 0 0 6 16.278c0 2.803 3.04 3.787 5.866 3.718 2.825.072 5.865-.915 5.865-3.719a5.33 5.33 0 0 0-1.58-3.54 6.8 6.8 0 0 1-1.793-3.148m1.826-2.857c-.517.48-1.16.803-1.854.93a.663.663 0 0 1-.842-.842c.128-.693.45-1.336.93-1.853a3.7 3.7 0 0 1 1.856-.932.663.663 0 0 1 .842.842 3.7 3.7 0 0 1-.932 1.855"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.2 4.013a2.666 2.666 0 0 1 2.666 2.666v2.133"
  })));
};
export default SvgPear;